import { gql } from '@apollo/client';
 
 
 
const getTroubleshooterQuery = gql`
  query MyQuery($whereCondition: core_AutomationJSON_returning, $limit: Int, $offset: Int = 0, $order: [core_AutomationJSON_order_by!]) {
    core_AutomationJSON(where: $whereCondition, limit: $limit, offset: $offset, order_by: $order) {
      automationName
      dartid
      description
      subCategory
      category
      jsonValue
    }
  }
`;
 
 
const getTroubleshooterCntQuery = gql`
query MyQuery($whereCondition: core_AutomationJSON_bool_exp) {
  core_AutomationJSON(where: $whereCondition) {
    automationName
    description
    category
    subCategory
    jsonValue
  }
}
`;
 
 
 
 
const setExecuteTroubleShooter = gql`
mutation AddRemoteJobs($userId: Int=0, $OS: String! = "unknown", $type: String!, $name: String!, $Dart: Int = 286,  $variable: String!, $shortDesc: String!, $Jobtype: String! = "Interactive", $ProfileName: String!,  $NotificationWindow: Int = 0, $ProfileOS: String! = "common")
{
  AddRemoteJobs(userId:$userId, OS: $OS, type: $type, name: $name, Dart: $Dart, variable: $variable, shortDesc: $shortDesc, Jobtype: $Jobtype, ProfileName: $ProfileName, NotificationWindow: $NotificationWindow, ProfileOS: $ProfileOS) {
    code
    Duplicates
    ProgServiceTag
    ServiceTagNotSupported
    ServiceTagSupported
    bid
    notifyRes
    onlineOffline
    searchtype
  }
}
`;
const deletePendingJob = gql`
mutation MyMutation($applicationname: String!, $tenant: String!) {
  delete_communication_Audit(where: {Dart: {_eq: 286}, ProfileName: {_eq: $applicationname}, AgentName: {_eq: $tenant}, JobStatus: {_eq: 0}}) {
    affected_rows
  }
}
 
`
const getPendingJobStatus = gql`
query getPendingJobStatus($applicationname: String!, $tenant: String!) {
  communication_Audit(where: {ProfileName: {_eq: $applicationname}, AgentName: {_eq: $tenant}, Dart: {_eq: 286}, JobStatus: {_eq: 0}}) {
    AgentName
    AID
  }
}
 
`
 
 
 
export { getTroubleshooterQuery, getTroubleshooterCntQuery, setExecuteTroubleShooter, getPendingJobStatus, deletePendingJob }
 